import { useHttpRequestPage } from "./useHttpRequestPage";
import { usePageFromCurrentRoute } from "./usePageFromCurrentRoute";
import { useRouteParams } from "./useRouteParams";

export function useHttpRequestPageForCurrRoute() {
	const { documentId } = useRouteParams();
	const { pageMetadata } = usePageFromCurrentRoute();
	const pageId = pageMetadata?.id ?? "";
	const requestPage = useHttpRequestPage(documentId, pageId);

	// Route metadata may be briefly undefined during initial route/document loading.
	// Keep consumers in a loading state until we have a concrete page id.
	if (!pageMetadata) {
		return {
			...requestPage,
			setHttpRequestPage: async () => undefined,
			isLoading: true,
			isError: false,
		};
	}

	return requestPage;
}
